var App = App || {};

App.RecordingLink = (function ($) {
	"use strict";
	function RecordingLink(data) {
		data = data || {};
		this.key = data.key || "";
		this.title = data.title || "";
		this.description = data.description || "";
		this.recordedOn = data.recordedOn ? new Date(data.recordedOn) : null;
		this.url = data.url || "";
		this.password = data.password || "";
		this.formattedRecordedOn = ko.pureComputed(() => {
			if (!this.recordedOn) return "";
			return new Intl.DateTimeFormat("en-US", {
				month: "long", day: "numeric", year: "numeric",
				hour: "numeric", minute: "2-digit", hour12: true, timeZoneName: "short" 
			})
				.format(this.recordedOn)
				.replace(/\bAM\b|\bPM\b/, m => m.toLowerCase().replace("m", ".m."));
		});
	}

	const viewModel = {
		recordingLink: ko.observable(new RecordingLink()),
		navigateTo: function (data, event) {
			window.open(data.url);
			return;
		}
	}
	function getRecordingLink(productKey) {
		return $.ajax({
			url: `/api/webinars/recording_link/${productKey}`,
			contentType: 'application/json; charset=utf-8',
			method: 'GET',
			dataType: 'json'
		}).fail(function (jqXHR) {
			App.Base.ShowError("Unable to complete request. Please try again.");
		});
	}

	function init() {
		const $modal = $("#recording-speedbump");

		if ($modal.length) {
			ko.applyBindings(viewModel, $modal[0]);

			$modal.on("show.bs.modal", function (event) {

				const $trigger = $(event.relatedTarget);

				if (!$trigger.length)
					return;

				getRecordingLink($trigger.data("product-key") || "")
					.done(function (response) {
						if (!response) {
							App.Base.ShowError("API did not respond.");
							return;
						};

						if (response.success && response.data) {
							viewModel.recordingLink(new RecordingLink(response.data));
							return;
						}
					});
			});
		}
	}

	return {
		init: init
	};

})(jQuery);

$(function () {
	App.RecordingLink.init();
});